export default __webpack_public_path__ + "static/media/potluck_home.4c01b414.webp";